<template>
  <div class="operator-selector">
    <div class="operator-selector-header" style="margin: 5px 0;">{{$t('operator-selector.title')}}</div>
    <div style="max-height: 230px;">
      <span
        v-if="operators.length === 0"
        class="no-operators text-muted"
        v-html="$t('operator-selector.unsupported-type')"
      />
      <div
        v-for="operator in operators"
        :key="operator.name"
        :class="{'is-selected': selectedOperator && operator.name === selectedOperator.name}"
        @click="onOperatorChange(operator)"
        class="d-flex operator-item"
      >
        <span class="flex-grow-1">{{operator.title}}</span>
      </div>
    </div>
  </div>
</template>

<script>
// import { filter } from "lodash";
// import Quill from "quill";
// import VariableHelpers from "@/assets/js/variableHelpers.js";
const operators = require("@/assets/js/operators.json");
export default {
  props: {
    selectedOperator: {
      type: Object
    },
    variableType: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    operators() {
      // console.log(operators)
      operators[0].title = this.$t("operators.equal");
      operators[1].title = this.$t("operators.not-equal");
      operators[2].title = this.$t("operators.bigger");
      operators[3].title = this.$t("operators.bigger/equal");
      operators[4].title = this.$t("operators.less");
      operators[5].title = this.$t("operators.less/equal");
      operators[6].title = this.$t("operators.contains");
      operators[7].title = this.$t("operators.not-contains");
      operators[8].title = this.$t("operators.set");
      operators[9].title = this.$t("operators.not-set");
      return operators.filter(
        o => o.validFor.indexOf(this.variableType.toLowerCase()) > -1
      );
    }
  },
  methods: {
    onOperatorChange(operator) {
      this.$emit("operator-changed", operator.name);
    }
  },
  components: {},
  watch: {
    variableType(vt) {
      if (
        this.selectedOperator &&
        !this.operators.find(o => o.name === this.selectedOperator.name)
      )
        this.onOperatorChange(this.operators[0]);
    }
  },
  mounted() {}
};
</script>

<style lang="less">
.operator-selector {
  color: #3d464a;
  background: #f5f5f5;
  width: 200px !important;
  height: 300px;
  max-height: 300px;
}

.operator-selector-header {
  color: #dbdada;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  user-select: none;
  padding: 0 20px;
}

.no-operators {
  padding: 0 20px;
}

.operator-item {
  padding: 0 20px;
  cursor: pointer;
  .operator-item-arrow {
    display: none;
  }

  &:hover,
  &.is-selected {
    background-color: rgba(219, 218, 218, 0.4);
    .operator-item-arrow {
      display: block;
    }

    &.is-selected {
      background-color: #dbdada;
    }
  }
}

// .var-item {
// 	padding: 0 20px;

// 	width: calc(100% + 20px);
// 	position: relative;

// 	.var-item-arrow {
// 		position: absolute;
// 		display: none;
// 		right: 20px;
// 		top: 0;
// 		width: 24px;
// 		height: 24px;
// 		background-color: #DBDADA;
// 		line-height: 23px;

// 		.var-item-arrow-icon {
// 			width: 6px;
// 		}
// 	}

// 	&:hover, &.is-selected {
// 		background-color: #DBDADA;

// 		.var-item-arrow {
// 			display: block;
// 		}
// 	}
// }

.no-border {
  border: 0 none;
}
</style>
